import React from 'react';
import Styled from 'styled';
import Localizable from 'lib/intl/localizable';
import { observer } from 'mobx-react';
import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';
import arrowDown from 'four-nets/icons/svg/icon_arrow-down.svg';
import defaultStyles from './select-view.scss';

@Localizable()
@Styled(defaultStyles)
@observer
class SelectView extends React.Component {
    static defaultProps = {
        field: {
            data: {},
        },
    };

    render() {
        const { id, onChange, field, intl, intlManager, styles, ...rest } = this.props;
        const { valid, visited, dirty, touched, validationErrors, onBlur, onClick } = field.data;
        const showValidationErrors = (visited || dirty || touched) && !valid;
        const { formatMessage } = intl;

        const classNames = [styles.select];

        if (showValidationErrors) {
            classNames.push(styles.invalid);
        }

        return (
            <div className={classNames.join(' ')}>
                <div className={styles.container}>
                    <SVGIcon src={arrowDown} className={styles.icon} />
                    <select
                        id={id}
                        className={styles.element}
                        onChange={onChange}
                        onBlur={onBlur}
                        onClick={onClick}
                        {...rest}
                    >
                        {this.props.children}
                    </select>
                </div>
                {showValidationErrors &&
                    validationErrors.map((error, index) => {
                        if (error.intlMessage) {
                            return (
                                <p key={index.toString()} className={styles.error}>
                                    {formatMessage(error.intlMessage)}
                                </p>
                            );
                        }
                        return null;
                    })}
            </div>
        );
    }
}

export default SelectView;
